import { Box } from "@chakra-ui/layout";
import { Row, Col } from "antd";
import useCreateBlocoQuadra from "core/features/bloco/hooks/useCreateBlocoQuadra";
import { BlocoQuadraForm } from "core/features/bloco/typings";
import { showErrorAxios } from "infra/helpers/alerta";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import DefaultButton from "ui/components/Button/PrimaryButton";
import Field from "../Field";

function FormBlocoQuadra({
  onSuccess,
  onClose,
  tenantId,
  visible,
  defaultValue,
}: {
  onSuccess: (data: any) => Promise<void>;
  onClose: () => void;
  tenantId: string;
  visible: boolean;
  defaultValue?: BlocoQuadraForm;
}) {
  const { control, handleSubmit, reset, formState } = useForm<BlocoQuadraForm>({
    reValidateMode: "onChange",
    mode: "onChange",
  });

  const { isLoading, mutate: handleSave } = useCreateBlocoQuadra(tenantId);

  const [isLocalLoading, setIsLocalLoading] = useState(false);

  useEffect(() => {
    reset({ ...defaultValue });
  }, [visible, defaultValue, reset]);

  const onSubmit = async (data: BlocoQuadraForm) => {
    handleSave(data, {
      onSuccess: async (res) => {
        reset();
        setIsLocalLoading(true);
        await onSuccess(res.data.id);
        setIsLocalLoading(false);
      },
      onError: (res) => {
        showErrorAxios(res);
      },
    });
  };

  return (
    <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
      <Row>
        <Box as={Col} md={24}>
          <Field
            label="Nome"
            control={control}
            name="nome"
            inputProps={{
              placeholder: "Nome do bloco/quadra",
            }}
            rules={{
              required: true,
            }}
          />
        </Box>
      </Row>

      <Box
        pt="32px"
        justifyContent="flex-end"
        d="flex"
        gridGap="8px"
        flexDir="row"
      >
        <DefaultButton
          backgroundColor={"gray.700"}
          onClick={() => {
            onClose();
            reset();
          }}
        >
          Cancelar
        </DefaultButton>

        <DefaultButton
          type="button"
          isLoading={isLoading || isLocalLoading}
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isValid || isLoading || isLocalLoading}
          minWidth={"120px"}
        >
          Salvar
        </DefaultButton>
      </Box>
    </form>
  );
}

export default FormBlocoQuadra;
